const googleAnalyticsId = `UA-XXXXX`

module.exports = {
  pathPrefix: `/gatsbystarter/gatsby-starter-mapbox-examples`,
  siteMetadata: {
    siteUrl: `https://astridx.github.io/gatsbystarter/gatsby-starter-mapbox-examples/`,
    title: `Milano Cortina 2026`,
    description: `Mobility Engineering Project`,
    author: `Pavel`,
    googleAnalyticsId,
    mapboxToken: `pk.eyJ1IjoidXNlcnBhdiIsImEiOiJja24zZmhxODAwOGpoMnZvMGpnZmtrNnhiIn0.62IOjLEwae3VzgbXme8MNg`,
  },
  plugins: [
    `gatsby-plugin-react-helmet`,
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    {
      resolve: `gatsby-plugin-styled-components`,
      options: {
        displayName: process.env.NODE_ENV !== `production`,
        fileName: false,
      },
    },
    {
      resolve: `gatsby-plugin-typography`,
      options: {
        pathToConfigModule: `./config/typography.js`,
      },
    },
    `gatsby-plugin-catch-links`,
  ],
}
